/**
 * Display name for a stored attachment key: the last path segment, with the
 * legacy invoice uuid suffix (`KGPL-INV-322-<uuid>.pdf`) reduced to the real
 * file name so old invoice mails read the same as new ones.
 */
export const attachmentDisplayName = (key) => {
  if (!key) return "-";
  const base = String(key).split(/[?#]/, 1)[0].split("/").pop() || String(key);
  const match = base.match(
    /^(.*)-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(\.[^.]+)$/i
  );
  return match ? `${match[1]}${match[2]}` : base;
};
